import { migrations } from "./migrations.js";
import { compareSemVer, semVerToString, toSemVer } from "./semver.js";
import { isIndexable } from "./utils.js";
import { APP_VERSION } from "./version.js";
export function migrateFiledata(savefile, toVersion) {
    if (!isIndexable(savefile) ||
        Array.isArray(savefile) ||
        !savefile["version"] ||
        typeof savefile["version"] !== "string") {
        return;
    }
    const fileVersion = toSemVer(savefile["version"]);
    const pendingMigrations = migrations
        .filter((migration) => compareSemVer(fileVersion, migration.version) < 0 &&
        (!toVersion ||
            compareSemVer(migration.version, toSemVer(toVersion)) <= 0))
        .sort((a, b) => compareSemVer(a.version, b.version));
    for (const migration of pendingMigrations) {
        savefile["data"] = migration.up(savefile["data"]);
        savefile["version"] = semVerToString(migration.version);
    }
    savefile["version"] = toVersion
        ? semVerToString(toSemVer(toVersion))
        : APP_VERSION;
    return savefile;
}
